module.exports = __webpack_public_path__ + "img/gold_back.c4f23a02.png";